// extracted by mini-css-extract-plugin
export default {"sjLogo":"HeaderLogo_sjLogo__lAPgW"};